import { render, staticRenderFns } from "./NoProductPage.vue?vue&type=template&id=4331961c&scoped=true&"
import script from "./NoProductPage.vue?vue&type=script&lang=js&"
export * from "./NoProductPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4331961c",
  null
  
)

export default component.exports